import Vue from 'vue'

import {library} from '@fortawesome/fontawesome-svg-core'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {
	faArrowLeft,
	faArrowRight,
	faBars,
	faChartBar,
	faChartPie,
	faCheckCircle,
	faCopy,
	faDatabase,
	faEdit,
	faEnvelope,
	faHandRock,
	faInfoCircle,
	faList,
	faMoneyBill,
	faPhone,
	faPlusSquare,
	faPoll,
	faQuestionCircle,
	faSave,
	faSearch,
	faSpinner,
	faStar,
	faSync,
	faTrash,
	faUsers,
	faEye, faClipboard, faLink, faCheck, faTimes, faTruck
} from '@fortawesome/free-solid-svg-icons'
import {faFacebook, faInstagram, faInstagramSquare, faPaypal, faWhatsapp} from '@fortawesome/free-brands-svg-icons'

library.add(faCheck, faTimes, faClipboard, faLink, faEye, faList, faPaypal, faSpinner, faPoll, faSave, faChartPie, faTruck,
	faSync, faPhone, faCopy, faInstagram, faChartBar, faUsers, faInstagramSquare, faFacebook, faEnvelope, faWhatsapp, faMoneyBill, faSearch, faInfoCircle, faStar, faArrowRight, faArrowLeft, faBars, faQuestionCircle, faEdit, faPlusSquare, faHandRock, faDatabase, faTrash, faCheckCircle
)

Vue.component('font-awesome-icon', FontAwesomeIcon)